import { CoreEnums } from '@/utils/domain/constants';
import {
  ApiOutlined,
  CloudOutlined,
  DatabaseOutlined,
  FolderOutlined,
  GoogleOutlined,
  LinkedinOutlined,
  OpenAIOutlined,
  ShareAltOutlined,
  WhatsAppOutlined,
  MailOutlined,
  ApiOutlined as ModelContextOutlined,
  FacebookOutlined,
  SendOutlined,
  PhoneOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import React from 'react';
import { getIntl } from 'umi';

const {
  ConnectionType,
  ApiSendParameterPosition,
  DatabaseType,
  HttpMethod,
  AuthorizationType,
  FtpFileTransferType,
  FtpAuthenticationMode,
  ServerType,
  McpLaunchMode,
  McpTransport,
  ConnectionGoogleCredentialType,
  ConnectionAzureGraphCredentialType,
} = CoreEnums;

import _ from 'lodash';

export const connectionTypeIcons = {
  AzureGraph: <CloudOutlined style={{ color: '#296DFF' }} />,
  OpenAI: <OpenAIOutlined style={{ color: '#296DFF' }} />,
  Google: <GoogleOutlined style={{ color: '#296DFF' }} />,
  Api: <ApiOutlined style={{ color: '#296DFF' }} />,
  Database: <DatabaseOutlined style={{ color: '#296DFF' }} />,
  AzureGraphSharePoint: <ShareAltOutlined style={{ color: '#296DFF' }} />,
  Ftp: <FolderOutlined style={{ color: '#296DFF' }} />,
  LinkedIn: <LinkedinOutlined style={{ color: '#296DFF' }} />,
  WhatsAppBusiness: <WhatsAppOutlined style={{ color: '#296DFF' }} />,
  SendGrid: <MailOutlined style={{ color: '#296DFF' }} />,
  ModelContextProtocol: <ModelContextOutlined style={{ color: '#296DFF' }} />,
  MetaPages: <FacebookOutlined style={{ color: '#296DFF' }} />,
  Smtp: <SendOutlined style={{ color: '#296DFF' }} />,
  Twilio: <PhoneOutlined style={{ color: '#296DFF' }} />,
  Sendblue: <MessageOutlined style={{ color: '#296DFF' }} />,
};

export const ConnectionTypeSelect = (isReadOnly = false) => {
  const intl = getIntl();

  return _.map(ConnectionType, (l, key) => {
    const translationKey = `connections.type.${key.toLowerCase()}`;
    const translatedText = intl.formatMessage({ id: translationKey });
    const icon = connectionTypeIcons[key];

    if (isReadOnly) {
      return {
        value: l,
        label: translatedText,
      };
    }

    return {
      value: l,
      searchLabel: translatedText,
      label: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px', pointerEvents: 'none' }}>
          {icon}
          <span style={{ pointerEvents: 'none' }}>{translatedText}</span>
        </span>
      ),
    };
  });
};

export const ConnectionTypeSelectForTable = () => {
  const intl = getIntl();

  return _.map(ConnectionType, (l, key) => {
    const translationKey = `connections.type.${key.toLowerCase()}`;
    const translatedText = intl.formatMessage({ id: translationKey });

    return {
      value: l,
      label: translatedText,
    };
  });
};

export const ConnectionTypeFilter = () => {
  return _.map(ConnectionType, (l, key) => {
    return {
      value: `Automy.Core.Enums.Connections.ConnectionType'${key}'`,
      label: `connections.type.${key.toLowerCase()}`,
    };
  });
};

export const apiSendParameterPositionSelect = () => {
  return _.map(ApiSendParameterPosition, (l, key) => {
    return { value: l, label: `connections.api.position.${key.toLowerCase()}` };
  });
};

export const ApiSendParameterPositionFilter = () => {
  return _.map(ApiSendParameterPosition, (l, key) => {
    return {
      value: `Automy.Core.Enums.ApiParameterPosition'${key}'`,
      label: `apiCallResponse.form.select.${key}`,
    };
  });
};
export const databaseTypeSelect = () => {
  const intl = getIntl();

  return _.map(DatabaseType, (l, key) => {
    const translationKey = `connections.database.databaseType.${key.toLowerCase()}`;
    const translatedText = intl.formatMessage({ id: translationKey });

    return {
      value: l,
      label: translatedText,
    };
  });
};

export const databaseTypeFilter = () => {
  return _.map(DatabaseType, (l, key) => {
    return {
      value: `Automy.Core.Enums.DatabaseType'${key}'`,
      label: `connections.database.type.${key.toLowerCase()}`,
    };
  });
};

export const httpMethodSelect = () => {
  return _.map(HttpMethod, (l, key) => {
    return { value: l, label: `connections.api.method.${key.toLowerCase()}` };
  });
};

export const httpMethodFilter = () => {
  return _.map(HttpMethod, (l, key) => {
    return {
      value: `Automy.Core.Enums.HttpMethod'${key}'`,
      label: `${key}`,
    };
  });
};

export const authorizationTypeSelect = () => {
  return _.map(AuthorizationType, (l, key) => {
    return { value: l, label: `connections.api.authorizationType.${key.toLowerCase()}` };
  });
};

export const authorizationTypeSelectForModelContext = () => {
  return [
    {
      value: AuthorizationType.NoAuth,
      label: `connections.modelcontextprotocol.authorizationType.noauth`,
    },
    {
      value: AuthorizationType.AutomyOnBehalfJwt,
      label: `connections.modelcontextprotocol.authorizationType.automyonbehalfjwt`,
    },
  ];
};

export const authorizationTypeFilter = () => {
  return _.map(AuthorizationType, (l, key) => {
    return {
      value: `Automy.Core.Enums.AuthorizationType'${key}'`,
      label: `connections.api.${key}`,
    };
  });
};

export const ftpFileTransferTypeSelect = () => {
  return _.map(FtpFileTransferType, (l, key) => {
    return { value: l, label: `${key}` };
  });
};

export const ftpAuthenticationModeSelect = () => {
  return _.map(FtpAuthenticationMode, (l, key) => {
    return { value: l, label: `connections.ftp.authenticationMode.${key.toLowerCase()}` };
  });
};

export const serverTypeSelect = () => {
  return _.map(ServerType, (l, key) => {
    return { value: l, label: `connections.serverType.${key}` };
  });
};

export const serverTypeFilter = () => {
  return _.map(ServerType, (l, key) => {
    return {
      value: `Automy.Core.Enums.ServerType'${key}'`,
      label: `connections.serverType.${key}`,
    };
  });
};

export const mcpLaunchModeSelect = () => {
  return [
    {
      value: McpLaunchMode.Remote,
      label: 'connections.modelcontextprotocol.launchMode.remote',
    },
    {
      value: McpLaunchMode.LocalProcess,
      label: 'connections.modelcontextprotocol.launchMode.localprocess',
    },
  ];
};

export const googleCredentialTypeSelect = () => {
  return [
    {
      value: ConnectionGoogleCredentialType.ServiceAccount,
      label: 'connections.google.credentialType.serviceaccount',
    },
    {
      value: ConnectionGoogleCredentialType.OAuthUser,
      label: 'connections.google.credentialType.oauthuser',
    },
  ];
};

export const azureGraphCredentialTypeSelect = () => {
  return [
    {
      value: ConnectionAzureGraphCredentialType.AppRegistration,
      label: 'connections.azuregraph.credentialType.appregistration',
    },
    {
      value: ConnectionAzureGraphCredentialType.PlatformOAuth,
      label: 'connections.azuregraph.credentialType.platformoauth',
    },
  ];
};

export const mcpTransportSelect = () => {
  return [
    {
      value: McpTransport.Stdio,
      label: 'connections.modelcontextprotocol.transport.stdio',
    },
    {
      value: McpTransport.Http,
      label: 'connections.modelcontextprotocol.transport.http',
    },
  ];
};
